import React, { useEffect, useRef, useState } from 'react';
import { Link } from "react-router-dom";
import DatePicker from "react-multi-date-picker";
import $ from 'jquery';
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import LightGallery from 'lightgallery/react';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import staff1 from '../../../../images/staff/member_2.png';
import staff2 from '../../../../images/staff/member_1.png';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';


const TeamAppointment = () => {
    const tableRef = useRef(null);
    const [month_fil_value, setMonthFilValue] = useState(new Date());

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };



    useEffect(() => {
        if (tableRef.current) {
            if (!$.fn.dataTable.isDataTable(tableRef.current)) {
                $(tableRef.current).DataTable({
                    "responsive": true,
                    pageLength: 25,
                    //   "aaSorting": [],
                    "ordering": false,
                    "language": {
                        "lengthMenu": "Show&nbsp;&nbsp; _MENU_",
                    },
                    "dom":
                        "<'row'" +
                        "<'col-sm-6 d-flex align-items-center justify-content-start mb-2'l>" +
                        "<'col-sm-6 d-flex align-items-center justify-content-end mb-2'f>" +
                        ">" +
                        "<'table-responsive'tr>" +
                        "<'row'" +
                        // "<'col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start mt-2'i>" +
                        // "<'col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end mt-2'p>" +
                        ">"
                });
            }
        }
    }, []);


    return (
        <>
            <div className="d-flex align-items-center justify-content-between flex-wrap page-titles px-0 py-1 mx-0">
                <div className='mb-2'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>Team Appointment</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Team Management</li>
                    </ol>
                </div>
                <div className='d-flex align-items-center gap-3 flex-wrap mb-2'>
                    <div className='datepicker-wrapper d-flex'>
                        <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                        <DatePicker
                            value={month_fil_value}
                            onChange={setMonthFilValue}
                            format="MMM-YYYY"
                            calendarPosition="top"
                            mode="single"
                            onlyMonthPicker={true}
                        />
                    </div>
                </div>
            </div>
            <div className="table-container mb-4">
                <table ref={tableRef} className="table align-top table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                    <thead>
                        <tr className="text-start align-top fw-bold fs-6 gs-0 bg-primary">
                            <th className="min-w-80px px-2 ">Sales Person</th>
                            <th className="min-w-50px px-1 text-center">AA</th>
                            <th className="min-w-50px px-1 text-center">MA</th>
                            <th className="min-w-50px px-1 text-center">CA</th>
                            <th className="min-w-50px px-1 text-center">PA</th>
                            <th className="min-w-50px px-1 text-center">CCR</th>
                            <th className="min-w-50px px-1 text-center">SR</th>
                            <th className="min-w-50px px-1 text-center">FR</th>
                            <th className="min-w-80px px-1 text-center">AAR</th>
                        </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold fs-7 align-top">
                        <tr>
                            <td>
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={staff1} className='border rounded px-1 py-0'>
                                            <img src={staff1} alt="Siva Sakthi" className='cursor-pointer w-45px h-45px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w400 fs-7'>Siva Sakthi</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">9897460204</label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>124</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>23</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>02</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>56</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>15</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>6.23%</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>5.26%</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>32.15%</label>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div className="d-flex align-items-center justify-content-start gap-2">
                                    <LightGallery
                                        onInit={onInit}
                                        speed={500}
                                        plugins={[lgThumbnail, lgZoom]}
                                    >
                                        <div data-src={staff2} className='border rounded px-1 py-0'>
                                            <img src={staff2} alt="Raj Pradeep" className='cursor-pointer w-45px h-45px' />
                                        </div>
                                    </LightGallery>
                                    <div>
                                        <label className='text-black font-w400 fs-7'>Raj Pradeep</label>
                                        <div className="d-block">
                                            <label className="fs-8 text-dark">9874587485</label>
                                        </div>
                                    </div>
                                </div>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>96</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>45</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>12</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>21</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#c0392b'}}>
                                <label className='fw-bold text-white fs-7'>03</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>12.54%</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>6.1%</label>
                            </td>
                            <td align='center' style={{backgroundColor : '#078d73'}}>
                                <label className='fw-bold text-white fs-7'>45.52%</label>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className='row mb-2 px-2 py-2 border border-gray800 rounded'>
                <div className='col-11 d-flex p-2 m-auto d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center'>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>All Appointment</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black'>
                            <span className='fs-5 fw-bold text-primary'>220</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Month Appointment</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black'>
                            <span className='fs-5 fw-bold text-primary'>68</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Completed Appointment</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black'>
                            <span className='fs-5 fw-bold text-primary'>14</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Cancelled Appointment</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black'>
                            <span className='fs-5 fw-bold text-primary'>77</span>
                        </div>
                    </div>
                </div>
                <div className='col-11 d-flex p-2 m-auto d-flex flex-wrap flex-lg-nowrap align-items-center justify-content-center'>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Pending Appointment</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black mt-4'>
                            <span className='fs-5 fw-bold text-primary'>18</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Success Rate</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black mt-4'>
                            <span className='fs-5 fw-bold text-primary'>18.77%</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>Failure Rate</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black mt-4'>
                            <span className='fs-5 fw-bold text-primary'>11.36%</span>
                        </div>
                    </div>
                    <div className='col-12 col-md-5 col-lg-2  border rounded text-center me-2'>
                        <div className='col-12 mb-2'>
                            <span className='text-black fw-semibold fs-6'>AAR - 3 Days</span>
                            <span className='d-block text-black fw-semibold fs-9'>(Average Appointment Ratio)</span>
                        </div>
                        <div className='col-12 fw-bold fs-4 text-black'>
                            <span className='fs-6 fw-bold text-primary'>77.67%</span>
                        </div>
                    </div>
                </div>
            </div> 
        </>
    )


}
export default TeamAppointment;